const getRewardUnits = ({
  bonusProgram,
  rewardName,
}: {
  bonusProgram: BonusTypes.BonusProgram;
  rewardName: string;
}): string | undefined => {
  const rewardField = bonusProgram.rewardFields.find(
    (field) => field.name === rewardName || field.displayName === rewardName,
  );

  return rewardField?.units;
};

export default getRewardUnits;
